import * as BuilderActionType from './constants';
import * as UnitHelper from 'helper/unit-helper';
import { AppSettings } from '../constants';

const defaultParams = {
  clientName: '',
  clientType: AppSettings.CLIENT_TYPE.Builder,
  skip: 1,
  take: 10,
  sort: { field: 'clientName', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ManageBuilder = {
  items: [],
  params: defaultParams
};

const BuilderProfile = {
  userId: '',
  email: '',
  firstName: '',
  lastName: '',
  fullName: '',
  clientName: '',
  userStatus: -1,
  UserStatusValue: ''
};

const BuilderOwnerProfile = {
  ownerEmail: '',
  ownerFirstName: '',
  ownerLastName: '',
  clientName: '',
  domain: '',
  clientStatus: 0,
  clientStatusValue: ''
};

const InviteBuilder = {
  IsHiddenSearchEmail: false,
  IsHiddenSystemBuilder: true,
  IsHiddenNonSystemBuilder: true,
  IsBack: false
};

const SetUpBuilderUser = {
  error: null,
  items: {},
  acceptCode: '',
  endPointApi: '',
  token: '',
  hasAccepted: null,
  userProfile: {},
  statusCompleted: null,
  setupSuccess: null
};

const EmailExistingBuilder = {
  ErrorMsg: [],
  succeeded: null
};

const BuilderConfigSite = {
  status: null,
  error: null
};

const BuilderAvatarName = {
  fullName: '',
  avatar: null
};

const BuilderState = {
  ManageBuilder: ManageBuilder,
  InviteBuilder: InviteBuilder,
  BuilderProfile: BuilderProfile,
  BuilderOwnerProfile: BuilderOwnerProfile,
  IsViewClientOwner: false,
  EmailExistingBuilder: EmailExistingBuilder,
  SetUpBuilderUser: SetUpBuilderUser,
  BuilderConfigSite: BuilderConfigSite,
  BuilderAvatarName: BuilderAvatarName,
  SettingDataGridColumn: {},
  PageSizeReference: {}
};

export default function BuilderStore(state = BuilderState, action) {
  switch (action.type) {
    case BuilderActionType.SEARCH_BUILDER_SUCCESS:
      return processSearch(state, action);
    case BuilderActionType.SEARCH_BUILDER_FOR_BULK_MAIL_SUCCESS:
      return processSearchForBulkMail(state, action);
    case BuilderActionType.GET_BUILDER_BY_EMAIL_SUCCESS:
      return processInvite(state, action);
    case BuilderActionType.GET_BUILDER_BY_ID_SUCCESS:
      return processGetByIdSuccess(state, action);
    case BuilderActionType.RESET_INVITE_BUILDER:
      return processResetInvite(state, action);
    case BuilderActionType.INVITE_BUILDER_SUCCESS:
      return processInviteSuccess(state, action);
    case BuilderActionType.RESET_BUILDER:
      return {
        ...state,
        ManageBuilder: {
          ...state.ManageBuilder,
          params: defaultParams
        }
      };
    case BuilderActionType.SETUP_BUILDER_USER_SUCCESS:
      return processSetupBuilderUserSuccess(state, action);
    case BuilderActionType.SETUP_BUILDER_USER_FAILED:
      return processSetupBuilderUserError(state, action);
    case BuilderActionType.CHECK_EMAIL_EXISTING_SUCCESS:
      return processCheckEmailExistingSuccess(state, action);
    case BuilderActionType.CONFIG_SITE_SUCCESS:
      return processConfigSiteSuccess(state, action);
    case BuilderActionType.CONFIG_SITE_FAILED:
      return processConfigSiteError(state, action);
    case BuilderActionType.CHECK_ACCEPTED_TOS_SUCCESS:
      return processCheckAcceptedTos(state, action);
    case BuilderActionType.CHECK_ACCEPTED_TOS_FAILED:
      return processCheckAcceptedTosError(state, action);
    case BuilderActionType.CHECK_SETUP_TENANT_COMPLETED_SUCCESS:
      return processSetupTenantCompleted(state, action);
    case BuilderActionType.BUILDER_SETUP_DATA_SUCCESS:
      return processSetUpDataSuccess(state, action);
    case BuilderActionType.GET_BUILDER_AVATAR_NAME_SUCCESS:
      return {
        ...state,
        BuilderAvatarName: action.data
      };
    case BuilderActionType.SET_SELECT_COLUMN:
      return processSetSelectColumn(state, action);
    case BuilderActionType.CLOSE_MODAL_BUILDER_INFORMATION:
      return {
        ...state,
        IsViewClientOwner: false
      };
    case BuilderActionType.SET_PAGE_SIZE_REFERENCE:
      return processSetPageSizeReference(state, action);
    default:
      return state;
  }
}

const processInvite = (state, action) => {
  var result = action.data.item === null ? BuilderProfile : action.data.item;

  var inviteBuilder = {
    IsHiddenSearchEmail: false,
    IsHiddenSystemBuilder: true,
    IsHiddenNonSystemBuilder: true,
    IsBack: false
  };

  if (!UnitHelper.isEmpty(result.userId)) {
    inviteBuilder.IsHiddenSearchEmail = true;
    inviteBuilder.IsHiddenSystemBuilder = false;
  } else {
    result.email = action.data.searchEmail;
    inviteBuilder.IsHiddenSearchEmail = true;
    inviteBuilder.IsHiddenNonSystemBuilder = false;
  }

  return {
    ...state,
    BuilderProfile: result,
    InviteBuilder: inviteBuilder
  };
};

const processInviteSuccess = state => {
  return {
    ...state,
    InviteBuilder: { ...InviteBuilder, IsBack: true }
  };
};

const processResetInvite = state => {
  return {
    ...state,
    InviteBuilder: {
      IsHiddenSearchEmail: false,
      IsHiddenSystemBuilder: true,
      IsHiddenNonSystemBuilder: true,
      IsBack: false
    }
  };
};

const processSearch = (state, action) => {
  var result = action.data;
  var manageBuilder = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      clientName: result.params.clientName,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageBuilder: manageBuilder,
    ErrorMsg: [],
    IsViewClientOwner: false,
    SuccessMsg: ''
  };
};

const processSearchForBulkMail = (state, action) => {
  var result = action.data;
  var manageBuilder = {
    items: result.items,
    params: defaultParams
  };

  return {
    ...state,
    ManageBuilder: manageBuilder,
    ErrorMsg: [],
    IsViewClientOwner: false,
    SuccessMsg: ''
  };
};

const processGetByIdSuccess = (state, action) => {
  var result = action.data.item;
  result['description'] = 'Site\'s super admin';
  return {
    ...state,
    BuilderOwnerProfile: result,
    IsViewClientOwner: true
  };
};

const processSetupBuilderUserSuccess = (state, action) => {
  const result = action.data;
  return {
    ...state,
    SetUpBuilderUser: {
      ...SetUpBuilderUser,
      items: result
    }
  };
};

const processSetupBuilderUserError = (state, action) => {
  const result = action.data;
  return {
    ...state,
    SetUpBuilderUser: {
      ...SetUpBuilderUser,
      error: result.error
    }
  };
};

const processCheckEmailExistingSuccess = (state, action) => {
  const result = action.data;
  return {
    ...state,
    EmailExistingBuilder: {
      ...EmailExistingBuilder,
      succeeded: result.succeeded,
      ErrorMsg: result.errors
    }
  };
};

const processConfigSiteSuccess = (state, action) => {
  const result = action.data;
  return {
    ...state,
    BuilderConfigSite: {
      ...BuilderConfigSite,
      status: result
    }
  };
};
const processConfigSiteError = (state, action) => {
  const result = action.data;
  return {
    ...state,
    BuilderConfigSite: {
      ...BuilderConfigSite,
      error: result.error
    }
  };
};

const processCheckAcceptedTos = (state, action) => {
  const result = action.data;
  return {
    ...state,
    SetUpBuilderUser: {
      ...SetUpBuilderUser,
      ...result
    }
  };
};

const processCheckAcceptedTosError = (state, action) => {
  const result = action.data;
  return {
    ...state,
    SetUpBuilderUser: {
      ...SetUpBuilderUser,
      error: result.error
    }
  };
};

const processSetupTenantCompleted = (state, action) => {
  const result = action.data;
  return {
    ...state,
    SetUpBuilderUser: {
      ...SetUpBuilderUser,
      statusCompleted: result.item
    }
  };
};

const processSetUpDataSuccess = (state, action) => {
  const result = action.data;
  return {
    ...state,
    SetUpBuilderUser: {
      ...SetUpBuilderUser,
      setupSuccess: result
    }
  };
};

const processSetSelectColumn = (state, action) => {
  const { id, type, data } = action.params;
  const settingDataGridColumn = {
    ...state.SettingDataGridColumn,
    [id]: {
      ...state.SettingDataGridColumn[id],
      [type]: data
    }
  };
  return {
    ...state,
    SettingDataGridColumn: settingDataGridColumn
  };
};

const processSetPageSizeReference = (state, action) => {
  const { params } = action;

  const { clientId, userId, tableName, pageSize } = params;

  const newNodeUserId = state.PageSizeReference[clientId]
    ? {
      ...state.PageSizeReference[clientId][userId],
      [tableName]: pageSize
    }
    : {
      [tableName]: pageSize
    };

  const newPageSizeReference = {
    ...state.PageSizeReference,
    [clientId]: {
      ...state.PageSizeReference[clientId],
      [userId]: newNodeUserId
    }
  };

  return {
    ...state,
    PageSizeReference: newPageSizeReference
  };
};



// WEBPACK FOOTER //
// ./src/Builders/reducers.js